import { Link } from 'react-router-dom';
import { Truck } from 'lucide-react';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { SHIPPING_SECTIONS } from '../../content/site-pages';
import { ROUTES } from '../../constants/routes';

export function ShippingPage() {
  return (
    <StaticPageLayout
      title="Shipping & Delivery"
      subtitle="Same-day delivery from local boutiques"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Truck className="h-5 w-5 text-primary" />
        </div>
        <p className="text-sm text-body leading-relaxed">
          Fash delivers orders directly from participating boutiques to your door.
          Delivery times and fees depend on your location and the boutique fulfilling your order.
        </p>
      </div>

      <Card>
        <CardContent className="p-0 divide-y divide-gray-100">
          {SHIPPING_SECTIONS.map((item) => (
            <div key={item.question} className="p-5">
              <h2 className="font-medium text-heading text-sm mb-2">{item.question}</h2>
              <p className="text-sm text-body leading-relaxed">{item.answer}</p>
            </div>
          ))}
        </CardContent>
      </Card>

      <p className="text-sm text-body text-center">
        Have a question about your delivery?{' '}
        <Link to={ROUTES.contact} className="text-primary hover:underline">
          Contact support
        </Link>{' '}
        or visit our{' '}
        <Link to={ROUTES.faq} className="text-primary hover:underline">
          FAQ
        </Link>
        .
      </p>
    </StaticPageLayout>
  );
}
